<template>
  <div class="btn-group" role="group">
    <button
      id="botaoModoTabela"
      data-test-id="button-modo-tabela"
      :class="modoResultado === 'T' ? 'active' : ''"
      type="button"
      name="botaoModoTabela"
      class="btn btn-primary"
      @click.prevent="alterarModo('T')"
    >
      <span class="fa fa-bars" />
    </button>
    <button
      id="botaoModoFicha"
      data-test-id="button-modo-ficha"
      :class="modoResultado === 'C' ? 'active' : ''"
      type="button"
      name="botaoModoFicha"
      class="btn btn-primary"
      @click.prevent="alterarModo('C')"
    >
      <span class="fa fa-th" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'ToolbarModoResultado',
  props: {
    modoResultado: {
      type: String,
      required: true,
    },
  },
  methods: {
    alterarModo(modo) {
      this.$emit('modoAlterado', modo)
    },
  },
}
</script>
